import React, { useEffect, useState } from "react";
import { styled, alpha } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import { useHistory } from "react-router";

import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Avatar from "@mui/material/Avatar";
import SearchIcon from "@mui/icons-material/Search";
import NestedList from "../../plugins/provider/nestedMenu";
import MoreIcon from "@mui/icons-material/MoreVert";
import Drawer from "@mui/material/Drawer";
import Autocomplete from "@mui/material/Autocomplete";
import { LogoutComponent } from "../../auth/logout";
import { Link } from "react-router-dom";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import MB from "../../assets/MB.png";
import { Chip } from "@mui/material";
import { getProviderArray } from "./Helper/utils";
import { getDoctorList } from "./Helper/API";
import { Search, SearchIconWrapper, StyledInputBase } from "./StyledComponent";
import { EVENTS } from "./events_Constant"
import { logEventToAnalyticsPlatform } from "../../helper/events"




export default function TopNavBarDoctorManagement(props) {
  const user = JSON.parse(localStorage.getItem("user_details"));
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(false);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(false);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const firstName = localStorage.getItem("user_details") ? JSON.parse(localStorage.getItem("user_details")).firstName : "";
  const [searchName, setSearchName] = React.useState("");
  const [searchId, setSearchId] = React.useState("");
  const searchNameLabels = [
    { id: 1, label: "First Name" }
  ];
  const childProviders = user?.parentProvider?.isParent ?? null ? user.parentProvider.childEntities : {};
  const childProviderOptions = [];
  Object.keys(childProviders).forEach((prov) => {
    childProviderOptions.push({
      id: prov,
      label: childProviders[prov],
    });
  });
    const providerFullName = user?.entityName;
  const [triggerSearch, setTriggerSearch] = React.useState(false)

  const clearFilters = () => {
    setSearchId("");
    setSearchName("");
    fetchDoctorData(true);
  };

  const [state, setState] = React.useState({
    left: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const toggleDrawerOnClick = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
    return open;
  };

  const createAppointment = () => {
    history.push("/" + localStorage.getItem("roleName") + "/create/appointments");
  };

  const showAppointment = () => {
    history.push("/" + localStorage.getItem("roleName") + "/appointments");
  };

  const searchByName = (event, values) => {
    values && values.label ? setSearchName(values.label) : setSearchName("");
  };

  const searchById = (event) => {
    setSearchId(event.target.value);
  };

  const fetchDoctorData = async (clearAll = false) => {
    try {
      let providerArray = getProviderArray();
      props.setIsLoading(true);
      let data = {
        qcStatus: props.activeQCStatusFilterArray,
        doctorSpecializations: props.activeSpecialityFilterArray,
        ...(props.activeProfileStausFilter !== undefined && { profileStatus: [props.activeProfileStausFilter] }),
        providerIds: props.selectedProviders?.length ? props.selectedProviders.map((val) => parseInt(val.id)) : providerArray,
        "operation": "AND",
        startIndex: 1,
        range: 10,
      }
      if ( searchId != "" && (!clearAll)) {
        data.getDoctorsByDoctorName = true;
        data.doctorNames = [searchId];
      }
      const resp = await getDoctorList(data);
      logEventToAnalyticsPlatform({
        name: EVENTS.PC_LS_ACTION.name,
        payload: {
          tab_name: EVENTS.TAB_NAME_LC_SCREEN,
          reference_id: '',
          reference_provider_id: '',
          filterValue: JSON.stringify([...props.activeQCStatusFilterArray, ...props.activeSpecialityFilterArray, props.activeProfileStausFilter, data.doctorNames]),
          service_name: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
          action: EVENTS.ACTION.FILTER,
        },
        schema: EVENTS.PC_LS_ACTION.schema,
      })
      props.setDoctorList(resp.data);
      props.setTotalRecords(resp.data.totalRecords);
      props.setIsLoading(false);
    } catch (err) {
      console.log(err);
      props.setIsLoading(false)
    }
  };

  const list = (anchor) => (
    <Box sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }} role="presentation" onKeyDown={toggleDrawer(anchor, false)}>
      <NestedList
        service={localStorage.getItem('serviceSelected')}
        toggleDrawerFunction={toggleDrawerOnClick(anchor, false)}
        anchorValue={anchor}
      ></NestedList>
    </Box>
  );

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={createAppointment}>Profile</MenuItem>
      <MenuItem onClick={showAppointment}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
      className="flex justify-start w-96"
    >
      <LogoutComponent mobileView={true}></LogoutComponent>
    </Menu>
  );

  const handleChange = async (event, newValue) => {
    !newValue && props.setSelectedProviders([]);
    props.setSelectedProviders(newValue);
    setTriggerSearch(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchDoctorData();
    };

    if (props.selectedProviders.length || triggerSearch) {
      fetchData();
    }
  }, [props.selectedProviders]);

  return (
    <Box sx={{ flexGrow: 1 }} className="sticky inset-x-0 top-0 opacity-100 z-20">
      <AppBar position="static">
        <Toolbar className="bg-nav-bar-header h-16">
          <IconButton size="large" edge="start" color="inherit" aria-label="open drawer" sx={{ mr: 2, color: "#000000" }}>
            <React.Fragment key={"left"}>
              <MenuIcon onClick={toggleDrawer("left", true)} />
              <Drawer anchor={"left"} open={state["left"]} onClose={toggleDrawer("left", false)}>
                {list("left")}
              </Drawer>
            </React.Fragment>
          </IconButton>
          <div className="flex p-0.5 rounded">
            <Link to={{ pathname: "/" }}>
              <div>
                <img src={MB} width="120px" alt="logo of provider"></img>
              </div>
              <div
                style={{ fontSize: "12px", color: "#050A4E" }}
                className="font-extrabold"
              >
                PROVIDER CENTRAL
              </div>
            </Link>
          </div>

          <Autocomplete
            sx={{
              marginLeft: "40px",
              display: "inline-block",
              fontSize: "13px",
              "& input": {
                width: "130px",
                padding: "9px",
                cursor: "pointer",
                color: "#000000",
              },
            }}
            id="custom-input-demo"
            options={searchNameLabels}
            inputValue={searchName}
            value={searchName}
            onChange={searchByName}
            onInputChange={(_, newInputValue) => {
              setSearchName(newInputValue);
            }}
            renderInput={(params) => (
              <div ref={params.InputProps.ref} className="flex relative">
                <input type="text" {...params.inputProps} placeholder="Search By" />
              </div>
            )}
          />

          <Search>
            <StyledInputBase
              sx={{
                width: "280px",
                fontSize: "13px"
              }}
              value={searchId}
              onChange={searchById}
              placeholder="Search..."
              inputProps={{ "aria-label": "search", "max-width": "150px" }}
              onKeyPress={(e) => {
                if (e.key === "Enter"  && searchName) fetchDoctorData();
              }}
            />
            {searchId && searchName && (
              <SearchIconWrapper
                onClick={() => {
                  clearFilters();
                }}
              >
                <HighlightOffIcon className="text-black" />
              </SearchIconWrapper>
            )}
            {searchId && searchName ? (
              <SearchIconWrapper onClick={() => fetchDoctorData()}>
                <SearchIcon className="text-black"></SearchIcon>
              </SearchIconWrapper>
            ) : (
              <SearchIconWrapper>
                <SearchIcon className="bg-white text-black"></SearchIcon>
              </SearchIconWrapper>
            )}
          </Search>
          <Box sx={{ flexGrow: 1 }} />
          {childProviderOptions && childProviderOptions.length > 0 ? (
            <FormControl sx={{ p: 0, width: 300, fontSize: "13px", height: "35px" }} size="small">
              <Autocomplete
                multiple
                className="bg-white"
                disableCloseOnSelect
                size="small"
                value={props.selectedProviders}
                sx={{
                  display: "inline-block",
                  ".MuiOutlinedInput-notchedOutline": { border: 0 },
                  "& input": {
                    fontSize: "13px",
                    cursor: "pointer",
                    color: "#000000",
                  },
                }}
                onChange={(event, newValue) => handleChange(event, newValue)}
                options={childProviderOptions}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderTags={(value, getTagProps) => (
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "nowrap",
                      overflowX: "auto",
                      alignItems: "center",
                    }}
                  >
                    {value.map((option, index) => (
                      <Chip {...getTagProps({ index })} key={option.id} label={option.label} size="small" />
                    ))}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Providers"
                    InputProps={{
                      ...params.InputProps,
                      style: {
                        display: "flex",
                        flex: 1,
                        height: "auto",
                        alignItems: "center",
                      },
                    }}
                    sx={{
                      "& .MuiInputBase-root": {
                        flexWrap: "nowrap",
                      },
                      "& .MuiInputBase-input": {
                        width: 0,
                        minWidth: 30,
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          ) : (
            <div style={{ padding: "7px", width: 300 }} className="text-black text-sm rounded-sm bg-white">
              {providerFullName}
            </div>
          )}

          <Box sx={{ display: { xs: "none", md: "flex" } }} className="m-2">
            <IconButton size="large" aria-label="account of current user" className="cursor-default" aria-haspopup="true" color="inherit">
              <Avatar className="uppercase text-center" sx={{ width: 30, height: 30, fontSize: "15px", bgcolor: "#dc3e4d" }}>
                {firstName?.charAt(0)}
              </Avatar>
            </IconButton>
            <LogoutComponent mobileView={false}></LogoutComponent>
          </Box>
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              className="text-gray-100"
            >
              <MoreIcon className="text-gray-100" />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </Box>
  );
}
